

<template>
	<div>
		<vFormItem :label="$t('fbb.warehouse.user_customer',{defaultValue:'可使用的客户'})" label-width="150" v-if="type!=='query'">
			<vTransfer
				style="height:360px;"
				:data="getAllNowManageOrgList"
				identifier="value"
				:target-keys="targetKeys"
				:list-style="listStyle"
				:render-format="renderFormat"
				filterable
                :filter-method="filterMethod"
				@on-transfer="handleChange"
			></vTransfer>
		</vFormItem>
		<TableList v-else v-bind="getTableProps"></TableList>
	</div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpCarrierServiceCustomeList } from '@/service/basicdata';
import { mapGetters } from 'vuex';
export default {
	props: ['data'],
	components: {
		TableList
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			targetKeys: this.data,
			listStyle: {
				width: '30%',
				minWidth: '260px'
			},
		}
	},
	watch: {
		data(val) {
			// console.log(this.getOrgList)
			this.targetKeys = val || []
		}
	},
	computed: {
		...mapGetters('dictionary', ['getAllNowManageOrgList']),
		getTableProps() {
			return {
				ajaxRequest: HttpCarrierServiceCustomeList,
				startUp: 1,
				initFormData: {
					id: this.id,
				},
				columns: [{
					title: this.$t('fbb.warehouse.sequence', { defaultValue: '序号' }),
					type: 'index',
					width: 100,
				}, {
					title: this.$t('fbb.warehouse.customer_list', { defaultValue: '客户名称' }),
					key: 'key',
					render: (h, { row }) => this.findRenderLabel(this.getAllNowManageOrgList, row.key)
				}]
			}
		},
	},
	methods: {
		renderFormat(item) {
			return item.description ? `${item.label}-${item.description}` : item.label;
		},
		handleChange(targetKeys, direction, moveKeys) {
			// console.log(targetKeys)
			this.targetKeys = targetKeys;
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
	}
}
</script>
